import { Divider, Pagination, Card } from 'antd';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../methods/redux/hooks';
import { getSwapReport } from '../../../methods/redux/reducers/accountant-report';
import remakeQueryString from '../../../methods/utils/remake-query-string';
import TransactionItem from '../../../transactions/transaction-statments/TransactionItem';
import AccountantsDateSelector from '../DateSelector';
import DownloadCSV from '../DownloadCSV';

const Style = styled(Card)``;

const SwapAccountantReport = () => {
	const dispatch = useAppDispatch();

	const [searchParams, setSearchParams] = useSearchParams();

	const { swap } = useAppSelector((store) => store.accountantsReport);

	const updateQueryString = (query: any, action = 'update') => {
		remakeQueryString(query, searchParams, setSearchParams, action);
	};

	useEffect(() => {
		const queryData = Object.fromEntries(searchParams.entries());
		if (Object.keys(queryData).length > 0) {
			dispatch(
				getSwapReport({
					...queryData,
				})
			);
		}
	}, [searchParams]);

	return (
		<Style>
			<h1>Swap Report</h1>

			<Divider />

			<AccountantsDateSelector onGetReport={updateQueryString} />

			{swap.record.itemsList.length > 0 && (
				<>
					<Divider />

					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={swap.record.paginator.itemCount}
						current={swap.record.paginator.currentPage}
						pageSize={swap.record.paginator.perPage}
					/>

					<br />

					<div>
						<DownloadCSV title="swap" csv={swap.record?.reportCSVFile} />
					</div>

					<br />

					{swap.record.itemsList.map((item: any) => (
						<TransactionItem key={item._id} transaction={item} />
					))}

					<Divider />
					<Pagination
						onChange={(pageId) => updateQueryString({ pageId })}
						total={swap.record.paginator.itemCount}
						current={swap.record.paginator.currentPage}
						pageSize={swap.record.paginator.perPage}
					/>
				</>
			)}
		</Style>
	);
};

export default SwapAccountantReport;
